import { createContext, type ReactNode } from "react";

/**
 * Lets a Panel publish its footer (CTA) so the surrounding Drawer can render it
 * in the fixed `trailing` slot at the bottom, outside the scrollable body.
 */
export const PanelFooterContext = createContext<(footer: ReactNode) => void>(
  () => {},
);
